import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import BookIcon from '@mui/icons-material/Book';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HistoryIcon from '@mui/icons-material/History';
import SchoolIcon from '@mui/icons-material/LibraryBooks';
import {NavigateFunction} from 'react-router';
import {env} from '../../config/env';

export const createNavBarMenu = (navigate: NavigateFunction) =>
  [
    {label: 'Study', icon: <BookIcon />, onClick: () => navigate('/')},
    ...(env.isDev
      ? [
          {label: 'Exercise', icon: <SchoolIcon />, onClick: () => navigate('/exercise')},
          {label: 'Sessions', icon: <HistoryIcon />, onClick: () => navigate('/sessions')},
        ]
      : []),
    {label: 'Todo', icon: <CheckCircleIcon />, onClick: () => navigate('/todo')},
    // {label: 'Groups', icon: <GroupsIcon />, onClick: () => navigate('/groups')},
  ] as AvatarMenuItem[];
